var _excluded = ["type", "items", "allowOneItemOpen", "collapseOnChildClick", "selectedTabIndex", "startIndex", "allAreOpen"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div, List, ListItem, P } from '@kizi/core-components';
import React, { useEffect, useMemo, useState } from 'react';
import { IconV2 as Icon } from './IconV2';
import withExpandable from './HOCs/withExpandable';
export var expandedHandler = function expandedHandler(index, expanded, list) {
  return list.map(function (item, i) {
    if (index === i && expanded) {
      return {
        isOpen: true,
        index: index
      };
    }

    if (index === i && !expanded) {
      return {
        isOpen: false,
        index: index
      };
    }

    if (index !== i && item.isOpen === expanded) {
      return {
        isOpen: false,
        index: i
      };
    }

    return item;
  });
};
export var Accordion = function Accordion(_ref) {
  var type = _ref.type,
      items = _ref.items,
      _ref$allowOneItemOpen = _ref.allowOneItemOpen,
      allowOneItemOpen = _ref$allowOneItemOpen === void 0 ? false : _ref$allowOneItemOpen,
      _ref$collapseOnChildC = _ref.collapseOnChildClick,
      collapseOnChildClick = _ref$collapseOnChildC === void 0 ? false : _ref$collapseOnChildC,
      selectedTabIndex = _ref.selectedTabIndex,
      startIndex = _ref.startIndex,
      _ref$allAreOpen = _ref.allAreOpen,
      allAreOpen = _ref$allAreOpen === void 0 ? false : _ref$allAreOpen,
      listProps = _objectWithoutProperties(_ref, _excluded);

  var iconSize = 28;
  var caretSize = 16;
  var itemsInitialState = items.map(function (_, index) {
    return returnItemTabState(startIndex, index);
  });

  var _useState = useState(itemsInitialState),
      _useState2 = _slicedToArray(_useState, 2),
      itemsOpenedState = _useState2[0],
      setItemsOpenedState = _useState2[1];

  useEffect(function () {
    var newItemsState = items.map(function (_, index) {
      return returnItemTabState(startIndex, index);
    });
    setItemsOpenedState(newItemsState);
  }, [items]);

  var setCurrentExpandedItem = function setCurrentExpandedItem(index) {
    return function (expanded) {
      var newState = expandedHandler(index, expanded, itemsOpenedState);
      setItemsOpenedState(newState);
    };
  };

  var basicChildren = function basicChildren(label, index) {
    if (typeof label === 'string') {
      return /*#__PURE__*/React.createElement(P, {
        key: "accordion-label-".concat(index)
      }, label);
    }

    return label;
  };

  function returnItemTabState(tabIndex, index) {
    if (tabIndex === index) {
      return {
        isOpen: true,
        index: index
      };
    }

    return {
      isOpen: false,
      index: index
    };
  }

  useEffect(function () {
    var itemsUpdatedState = items.map(function (_, index) {
      return returnItemTabState(selectedTabIndex, index);
    });

    if (selectedTabIndex !== undefined) {
      setItemsOpenedState(itemsUpdatedState);
    }
  }, [selectedTabIndex]);
  var listItems = useMemo(function () {
    return items.map(function (_ref2, index) {
      var label = _ref2.label,
          content = _ref2.content,
          icon = _ref2.icon,
          _ref2$isClickable = _ref2.isClickable,
          isClickable = _ref2$isClickable === void 0 ? true : _ref2$isClickable;
      var children = basicChildren(label, index);

      if (type === 'pro-con') {
        var variant = '';
        var labelColor = 'main.2';
        var proConIcon = /*#__PURE__*/React.createElement(React.Fragment, null);
        var gridTemplateColumns = "auto ".concat(isClickable && content ? caretSize : 0, "px");

        if (icon === 'small-cancel') {
          variant = 'dangerBig';
          labelColor = 'second.0';
        }

        if (icon) {
          gridTemplateColumns = "".concat(iconSize, "px ").concat(gridTemplateColumns);
          proConIcon = /*#__PURE__*/React.createElement(Icon, {
            name: icon,
            size: iconSize,
            mr: 1,
            variant: variant
          });
        }

        children = function children(isOpen) {
          return /*#__PURE__*/React.createElement(Div, {
            display: "grid",
            gridTemplateColumns: gridTemplateColumns,
            gridGap: 1,
            key: "accordion-container-".concat(index),
            alignItems: "center"
          }, proConIcon, /*#__PURE__*/React.createElement(P, {
            variant: "footnoteRegular",
            color: labelColor
          }, label), content && isClickable && /*#__PURE__*/React.createElement(Icon, {
            name: "big-arrow-".concat(isOpen ? 'up' : 'down'),
            size: caretSize,
            variant: "accordion"
          }));
        };
      }

      var expandedStatus;
      var controlledExpanded;

      if (allowOneItemOpen && itemsOpenedState[index]) {
        expandedStatus = setCurrentExpandedItem(index);
        controlledExpanded = itemsOpenedState[index].isOpen;
      }

      if (!isClickable) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: "accordion-item-".concat(index)
        }, typeof children === 'function' ? children(false) : children);
      }

      var ExpandableLi = withExpandable(ListItem);
      return /*#__PURE__*/React.createElement(ExpandableLi, {
        _content: content,
        _asChild: collapseOnChildClick,
        key: "accordion-item-".concat(index),
        shareExpandedStatus: expandedStatus,
        controlledExpanded: allAreOpen || controlledExpanded
      }, children);
    });
  }, [items, itemsOpenedState]);
  return /*#__PURE__*/React.createElement(List, listProps, listItems);
};